import { Controller } from '@hotwired/stimulus'

const CONFETTI_COUNT = 48
const COLOR_TOKENS = [
  '--color-primary',
  '--color-accent',
  '--color-success',
  '--color-info',
  '--color-secondary',
]

// Draws a one-shot confetti burst on the signature confirmation screen.
// Colours are read from the active theme tokens so the burst follows the
// DS / custom-profile palette, and the whole thing is skipped when the
// user asked for reduced motion.
export default class extends Controller {
  static targets = ['confetti']

  connect() {
    if (this.prefersReducedMotion || !this.hasConfettiTarget) return
    this.renderConfetti()
  }

  get prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
  }

  renderConfetti() {
    const colors = this.themeColors()
    const fragment = document.createDocumentFragment()
    for (let i = 0; i < CONFETTI_COUNT; i++) {
      fragment.appendChild(this.buildPiece(i, colors))
    }
    this.confettiTarget.appendChild(fragment)
  }

  themeColors() {
    const styles = getComputedStyle(document.documentElement)
    const colors = COLOR_TOKENS
      .map((token) => styles.getPropertyValue(token).trim())
      .filter((value) => value.length > 0)
    return colors.length > 0 ? colors : ['currentColor']
  }

  buildPiece(index, colors) {
    const angle = (index / CONFETTI_COUNT) * Math.PI * 2 + Math.random()
    const distance = 90 + Math.random() * 160
    const tx = Math.round(Math.cos(angle) * distance)
    const ty = Math.round(Math.sin(angle) * distance + 60 + Math.random() * 80)
    const rotation = Math.round(Math.random() * 540 - 270)
    const duration = (0.9 + Math.random() * 0.7).toFixed(2)
    const delay = (Math.random() * 0.12).toFixed(2)
    const size = 6 + Math.round(Math.random() * 6)

    const piece = document.createElement('span')
    piece.className = 'sign-confetti-piece'
    piece.setAttribute('aria-hidden', 'true')
    piece.style.left = '50%'
    piece.style.top = '50%'
    piece.style.width = `${size}px`
    piece.style.height = `${size}px`
    piece.style.marginLeft = `${-size / 2}px`
    piece.style.marginTop = `${-size / 2}px`
    piece.style.borderRadius = index % 2 === 0 ? '50%' : '1px'
    piece.style.background = colors[index % colors.length]
    piece.style.setProperty('--tx', `${tx}px`)
    piece.style.setProperty('--ty', `${ty}px`)
    piece.style.setProperty('--rot', `${rotation}deg`)
    piece.style.setProperty('--cfb-duration', `${duration}s`)
    piece.style.setProperty('--cfb-delay', `${delay}s`)
    return piece
  }
}
